module.exports = __webpack_public_path__ + "fonts/3MCircularTT-BoldItalic.4da8ccd0.otf";